import React from 'react';
import {
  InputRightElement as ChakraInputRightElement,
  InputElementProps as ChakraInputElementProps,
} from '@chakra-ui/react';

export function InputRightElement(props: ChakraInputElementProps) {
  return <ChakraInputRightElement {...props} />;
}
